export default "__VITE_ASSET__BoN4TAoC__"